import { Link, Navigate } from "react-router-dom";
import { Clock, Home as HomeIcon, Loader2 } from "lucide-react";
import LSSDLogo from "../components/LSSDLogo";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";

/**
 * RegistrazioneInAttesa — visualizza dopo signup Google/tradizionale con profilo completo, in attesa HR.
 * Non è wrappato in ProtectedRoute perché deve essere raggiungibile da utenti con is_approved=false
 * (che ProtectedRoute reindirizzerebbe a /login?pending=1, nascondendo la conferma della registrazione).
 */
export default function RegistrazioneInAttesa() {
  const { user, loading, logout } = useAuth();

  // Attende il caricamento della sessione post-submit
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-[#0A1F18] flex items-center justify-center" data-testid="pending-loading">
        <Loader2 className="h-8 w-8 animate-spin text-sheriff-gold" />
      </div>
    );
  }
  // Utente già approvato → dashboard (non ha senso vedere la schermata "in attesa")
  if (user && user.is_approved) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-[#0A1F18] flex items-center justify-center px-4" data-testid="pending-approval-page">
      <div className="w-full max-w-md text-center">
        <div className="bg-[#143830] border border-sheriff-gold/25 rounded-xl p-10">
          <LSSDLogo className="h-20 w-20 mx-auto mb-6" />
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-3 py-1 mb-4">
            <Clock className="h-3.5 w-3.5 text-amber-300" />
            <span className="uppercase tracking-widest text-[10px] font-bold text-amber-300">In attesa di approvazione</span>
          </div>
          <h1 className="font-heading font-black text-2xl text-[#F5E6B8] mb-3">Registrazione ricevuta</h1>
          <p className="text-[#D4C480] text-sm leading-relaxed mb-6">
            Il Comando verificherà la tua identità e i dati IC forniti.
            Riceverai comunicazione sul tuo Discord al termine della verifica.
          </p>
          {user?.email && (
            <div className="text-xs text-[#8B7B49] font-mono mb-6">{user.email}</div>
          )}
          <div className="flex flex-wrap gap-2 justify-center">
            <Link to="/">
              <Button variant="outline" className="border-sheriff-gold/40 text-sheriff-gold hover:bg-sheriff-gold/10 rounded-full uppercase-label" data-testid="pending-home-btn">
                <HomeIcon className="h-4 w-4 mr-2" /> Torna al Sito
              </Button>
            </Link>
            <Button
              onClick={async () => { await logout(); window.location.href = "/"; }}
              variant="ghost"
              className="text-[#D4C480] hover:bg-white/5 rounded-full uppercase-label"
              data-testid="pending-logout-btn"
            >
              Esci
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
